const ACCESS_REQUEST = "ACCESS_REQUEST";
const ACCESS_APPROVED = "ACCESS_APPROVED";
const ACCESS_DENIED = "ACCESS_DENIED";

const REGISTER_REQUEST = "REGISTER_REQUEST";
const REGISTER_SUCCESS = "REGISTER_SUCCESS";
const REGISTER_FAILED = "REGISTER_FAILED";

const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
const SIGNOUT_FAILED = "SIGNOUT_FAILED";

module.exports = {
    ACCESS_REQUEST,
    ACCESS_APPROVED,
    ACCESS_DENIED,
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    REGISTER_FAILED,
    SIGNOUT_REQUEST,
    SIGNOUT_SUCCESS,
    SIGNOUT_FAILED
};